export const formatCompactCurrency = (value: number, locale = 'en-AU'): string =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'AUD',
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(value);
